import { ActionReducerMap } from '@ngrx/store';

import * as fromSapGlobal from './sap-globals';
import * as fromSapAssets from './sap-assets';
import { SapAssetsState } from '../models/reducers/sap-assets';

export interface AppState {
  [fromSapAssets.name]: SapAssetsState;
  [fromSapGlobal.name]: fromSapGlobal.SapGlobalState;
}

export const reducers: ActionReducerMap<AppState> = {
  [fromSapAssets.name]: fromSapAssets.reducer,
  [fromSapGlobal.name]: fromSapGlobal.reducer,
};

